import propTypes from 'prop-types';
export var onsiteMessageEventPropTypes = {
  eventData: propTypes.object,
  newLaneEventData: propTypes.object,
  additionalClickStreamData: propTypes.object,
  gaEventData: propTypes.shape({
    action: propTypes.string,
    label: propTypes.string,
    category: propTypes.string
  }),
  signalForTriggerTracking: propTypes.bool
};
export var defaultOnsiteMessageEventPropTypes = {
  eventData: {},
  newLaneEventData: {},
  additionalClickStreamData: {},
  gaEventData: {},
  signalForTriggerTracking: true
};